/**
 * ControlFormModal — `goal_id` select pulls from Step 7 goals
 * (injected at render time).
 */
import React, { useMemo } from 'react';
import FormModal from '../../../../components/ui/FormModal/FormModal';
import { CONTROL_FORM_FIELDS, type ControlRecord } from './controlsFieldSchema';

const FormModalAny = FormModal as unknown as React.ComponentType<any>;

export interface OptionLite { value: string; label: string; }

export interface ControlFormModalProps {
  mode: 'add' | 'edit';
  initialControl?: ControlRecord | null;
  goalOptions: OptionLite[];
  onSubmit: (values: Record<string, unknown>) => Promise<void>;
  onClose: () => void;
}

export default function ControlFormModal({
  mode,
  initialControl,
  goalOptions,
  onSubmit,
  onClose,
}: ControlFormModalProps) {
  const isEdit = mode === 'edit';
  const fields = useMemo(
    () => CONTROL_FORM_FIELDS.map((f) => {
      if (f.name === 'goal_id') return { ...f, options: goalOptions };
      if (isEdit && f.name === 'control_id') return { ...f, disabled: true };
      return f;
    }),
    [goalOptions, isEdit],
  );

  return (
    <FormModalAny
      title={isEdit ? 'Edit Control' : 'Add Control'}
      fields={fields}
      initialValues={initialControl ?? {}}
      submitLabel={isEdit ? 'Save Changes' : 'Add Control'}
      submittingLabel={isEdit ? 'Saving…' : 'Adding…'}
      onSubmit={onSubmit}
      onClose={onClose}
      maxWidth={680}
    />
  );
}
